import { useSelector } from 'react-redux';
import * as checkoutSelectors from '@/selectors/checkoutSelectors';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useOrderTotalsHook = () => useSelector((state) => checkoutSelectors.getAdditionalOrderTotals(state, {}));

export default useOrderTotalsHook;
